import { useLazyQuery, useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import toast from "react-hot-toast";
import { PmStore } from "@/state";





const mutationSetReservationPublished = gql`
  mutation setReservationPublished($organizationId: UUID!, $reservationId: UUID!, $published: Boolean!) {
    setReservationPublished(organizationId: $organizationId, reservationId: $reservationId, published: $published) 
  }
`;





export function useReservationActions() {
    const state = PmStore();
    const [apiSetReservationPublished] = useMutation(mutationSetReservationPublished);

    // const [apiGetResourceTags] = useLazyQuery(getResourceTagsQuery);





    async function SetReservationPublished(reservationId: string, published: Boolean) {
        let organizationId = state?.selectedOrganization?.id;
        try {
            let result = await apiSetReservationPublished({ variables: { organizationId, reservationId, published } }) as any;
            return result.data.setReservationPublished as Boolean;
        }
        catch (err) {
            toast.error("Api Error, Unable to set reservation published flag");
        }
    }





    return {
        SetReservationPublished
    };
}




